<template>
  <div id="app">
  <!-- <keep-alive> -->
     <router-view/>
  <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import './assets/css/main.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue